<template>
    <section>
        <b-modal id="add-to-invoice-modal" ref="add-to-invoice-modal" size="xl" title="Add to Invoice">
            <h6>Select the invoice you want to add the item to or click create new invoice.</h6>
            <grid-component
                isResizable
                isReorderable
                :gridId="gridId"
                :fields="fields"
                :itemData="itemData"
                :handleRowClick="onRowClick"
            />
            <template slot="modal-footer">
                <b-button variant="primary" v-if="!isReceivingPO" @click="onCreateNewInvoice" class="mr-auto" :disabled="isSaving">
                    <i v-if="isSavingNew" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>
                    Create New Invoice
                </b-button>
                <b-button @click="$bvModal.hide('add-to-invoice-modal')">Cancel</b-button>
                <b-button variant="primary" @click="onAddToInvoice" :disabled="selectedInvoice == 0 || isSaving">
                    <i v-if="isSavingAdd" class="fa fa-spinner fa-pulse fa-fw mr-1"></i>
                    Add to Invoice</b-button>
            </template>
        </b-modal>
    </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import fields from '../../../fields';
import { date } from '@/shared/filters';
import { GRID_ID } from '@/shared/constants';
import { prepareColumnsData } from '@/shared/helpers';
import GridComponent from '@/shared/components/GridComponent';

export default {
    components: {
        GridComponent
    },
    props: {
        companyId: {
            type: [Number, String],
            default: 0
        },
        SOLine: {
            type: Object,
            default: () => {}
        },
        isReceivingPO: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            fields,
            prepareColumnsData,
            selectedInvoice: 0,
            isSaving: false,
            isSavingAdd: false,
            isSavingNew: false,
            gridId: GRID_ID.ADD_TO_INVOICE_GRID
        }
    },
    computed: {
        ...mapGetters('invoices', ['openInvoices']),
        ...mapGetters('account', ['gridSettingsById']),
        gridSettings() {
            return this.gridSettingsById(this.gridId);
        },
        itemData() {
            let invoicesList = (this.companyId) ? this.openInvoices.filter(x => x.companyId == this.companyId) : this.openInvoices;

            return invoicesList.filter(x => !x.isProforma).map((item) => ({ ...item, selected: item.id === this.selectedInvoice }));
        },
    },
    filters: {
        date
    },
    methods: {
        ...mapActions('invoices', [
            'getOpenInvoices',
            'addInvoiceLine',
            'createNewInvoice'
        ]),
        onRowClick(e) {
            this.selectedInvoice = e.dataItem.id;
        },
        async onCreateNewInvoice() {
            this.isSaving = this.isSavingNew = true;
            await this.createNewInvoice({
                salesOrderId: this.SOLine.salesOrderId,
                companyId: this.SOLine.companyId,
                contactId: this.SOLine.contactId,
                salesOrderLineId: this.SOLine.id,
                salesOrderLineScheduleId: this.SOLine.scheduleId
            }).then((res) => {
                this.$bvModal.hide('add-to-invoice-modal');
                if (res.status == 200) {
                    this.$snotify.success('Created an Invoice successfully');
                    this.$emit('saved', res.data.id);
                }
            });

            this.onRefresh();
        },
        async onAddToInvoice() {
            if (this.isReceivingPO) {
                this.$emit('invoiceLineSelected', this.selectedInvoice);
                this.onRefresh();
            } else {
                this.isSaving = this.isSavingAdd = true;
                await this.addInvoiceLine({
                    id: this.selectedInvoice,
                    lines: {
                        salesOrderLineId: this.SOLine.id,
                        salesOrderLineScheduleId: this.SOLine.scheduleId
                    }
                }).then((res) => {
                    if (res.status == 200)
                        this.$snotify.success('Added to Invoice successfully');
                        this.$emit('saved', this.selectedInvoice);
                });
                this.onRefresh();
            }
        },
        onRefresh() {
            this.isSaving = false;
            this.isSavingAdd = false,
            this.isSavingNew = false,
            this.$bvModal.hide('add-to-invoice-modal');
            this.selectedInvoice = 0;
        }
    },
    mounted() {
        this.onRefresh();
        this.getOpenInvoices();
    }
};
</script>